'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:NavbarCtrl
 * @description
 * # NavbarCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp')
  .controller('NavbarCtrl', ['$scope','$rootScope','$location','Session',function ($scope,$rootScope,$location,Session) {

      var setupAuthentication = function () {

          var sessionObject = Session.getSessionObject();
          $scope.navbarSettings = {
              userAuthenticated: sessionObject.isAuthenticated,
              userName: sessionObject.username,
              isDirector: sessionObject.isDirector,
              isAlternate: sessionObject.isAlternate,
              isAdmin: sessionObject.isAdmin,
              isProjectAdmin: sessionObject.isProjectAdmin,
              isCurriculaAdmin: sessionObject.isCurriculaAdmin,
              isEventCreator: sessionObject.isEventCreator
          };
      };
      setupAuthentication();

      $rootScope.$on('login', setupAuthentication);

      $scope.logout = function() {
          console.log('Logout!');
          Session.logout().then(function () {
              var sessionObject = Session.getSessionObject();
              $scope.navbarSettings = {
                  userAuthenticated: sessionObject.isAuthenticated,
                  userName: sessionObject.username,
                  isDirector: sessionObject.isDirector,
                  isAlternate: sessionObject.isAlternate,
                  isAdmin: sessionObject.isAdmin,
                  isProjectAdmin: sessionObject.isProjectAdmin,
                  isCurriculaAdmin: sessionObject.isCurriculaAdmin,
                  isEventCreator: sessionObject.isEventCreator
              };
             $location.url('/');  //go back to the main page
         }, function() {
             $location.path('error');
         });
      };

  }]);
